var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from "react-hook-form";
import { Checkbox } from "@gravity-ui/uikit";
export var FormCheckbox = function (props) {
    var control = useFormContext().control;
    return (_jsx(Controller, { control: props.control || control, name: props.name, render: function (_a) {
            var field = _a.field;
            return (_jsx(Checkbox, __assign({}, props, field, { value: field.value, id: props.name, checked: field.value === true, onUpdate: function (checked) {
                    var _a;
                    field.onChange(checked);
                    (_a = props.onUpdate) === null || _a === void 0 ? void 0 : _a.call(props, checked);
                } })));
        } }));
};
